var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.14 98.47"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mouth_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-459.42-602.21h978.78V397.86h-978.78z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mouth_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.79 1.34c0 34.48 35.11 66.36 72.8 67.6h2.27v28.18C52.34 97.12 3.27 54.28 1.68 3.87V1.34z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.79 1.34c0 34.48 35.11 66.36 72.8 67.6h2.27v28.18C52.34 97.12 3.27 54.28 1.68 3.87V1.34z",
    stroke: "#ecb989",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    fill: "none"
  }))));
}
export default __webpack_public_path__ + "3ca2c8be28fa85a5b934c4b9330fff41.svg";
export { SvgMouth as ReactComponent };